import React, { Component } from 'react';
import { connect } from "react-redux";
import classnames from "classnames";

import { profileFetchIfNeeded } from './../../store/profile/actions';
import { profileUpdateStages } from "./../../store/profile/actions";

import Loader from './../shared/Loader'
import Button from './../shared/Button/index';

import {
  welcomeTitleMath,
} from 'custom/textWelcome';

import baseStyles from 'custom/base.styl';


class PageMathTestWelcome extends Component {
  constructor(props) {
    super(props)

    this._handleSubmit = this._handleSubmit.bind(this)
  }

  componentDidMount() {
    const { loadProfile } = this.props;
    loadProfile();
  }

  _handleSubmit(e) {
    e.preventDefault()

    this.props.profileUpdateStages()
  }

  render() {
    const { loading } = this.props;

    if (loading) {
      return <Loader absolute />
    }

    return (
      <div>
        <div className={baseStyles.header}><h1 className={baseStyles.title}>{welcomeTitleMath}</h1></div>
        <div className={classnames(baseStyles.content_board, baseStyles.centered, baseStyles.testing)}>
          <form onSubmit={this._handleSubmit} method="post">
            <p className={classnames(baseStyles.title_extra_small, baseStyles.mb_30)}>
              Almost halfway there! Do not stop, nail this test, and move to the last stage of our testing environment! Earning money from home can be that easy.
            </p>
            <p className={classnames(baseStyles.succeess_title)}>Math test will take up to 30 minutes of your time</p>

            <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__dark)}>
              <li>There are <b>15</b> multiple choice questions.</li>
              <li><b>Only one</b> answer is correct.</li>
              <li>You will <b>not be able to either pause or restart</b> the test.</li>
              <li>You will need to <b>answer all the questions</b> before the time runs out.</li>
            </ul>

            <Button type="submit">Start a test</Button>
          </form>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const loadingProfile = !state.profile || !state.profile.data || state.profile.data.isFetching;

  return {
    loading: loadingProfile
  }
};

const mapDispatchToProps = dispatch => ({
  loadProfile: () => {
    dispatch(profileFetchIfNeeded());
  },
  profileUpdateStages: () => { dispatch(profileUpdateStages()) },
});

export default connect(mapStateToProps, mapDispatchToProps)(PageMathTestWelcome)



// WEBPACK FOOTER //
// ./src/components/MathTest/PageMathTestWelcome.js